import api from '@/api'

function get (success, error) {
  return api.profile.get((profile) => {
    api.get(profile.company.collection('products'), success, error)
  }, error)
}

function sync (company, callbacks, error) {
  return api.subscribe(company.collection('products'), callbacks, null, error)
}

function list (success, error) {
  return api.profile.get((profile) => {
    api.get(profile.company.collection('products'), success, error)
  }, error)
}

function add (product, success, error) {
  return api.profile.get((profile) => {
    api.add(profile.company.collection('products'), product, success, error)
  })
}

export default {
  get,
  sync,
  list,
  add
}



// WEBPACK FOOTER //
// ./src/api/products.js